// IDs match the existing backend feed configuration. Other active catalog IDs
// use the generic route so adding a service does not require a website release.
export const SERVICE_HISTORY_PAGES = {
  zoom: { serviceId: 1, displayName: "Zoom", path: "/zoomstatus", logo: "zoom" },
  slack: { serviceId: 2, displayName: "Slack", path: "/slackstatus", logo: "slack" },
  teams: { serviceId: 3, displayName: "Microsoft Teams", path: "/teamsstatus", logo: "msteams" },
  googlemeet: { serviceId: 4, displayName: "Google Meet", path: "/googlemeetstatus", logo: "googlemeet" },
  gotomeeting: { serviceId: 6, displayName: "GoTo Meeting", path: "/gotomeetingstatus", logo: "gotomeeting" },
  webex: { serviceId: 7, displayName: "Webex", path: "/webexstatus", logo: "webex" },
  microsoft365: { serviceId: 41, displayName: "Microsoft 365", path: "/microsoft365status", logo: "microsoft365" },
};

export function serviceHistoryPath(serviceId) {
  return Object.values(SERVICE_HISTORY_PAGES).find(service => service.serviceId === Number(serviceId))?.path
    || `/services/${encodeURIComponent(serviceId)}/history`;
}
